import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  syncWithSafalMyBuy: null,
};

export const globalToggleSlice = createSlice({
  name: 'globalToggleSlice',
  initialState,
  reducers: {
    setGlobalToggleState: (state, action) => {
      const newState = { ...state, ...action.payload };
      return newState;
    },
    resetGlobalToggleState: () => {
      return initialState;
    },
  },
});

export const { setGlobalToggleState, resetGlobalToggleState } = globalToggleSlice.actions;

export default globalToggleSlice.reducer;
